import { BehaviorSubject, type Observable, of } from 'rxjs';
import type { TableDataSource, TablePage } from './table-data-source';

export class StaticArrayDataSource<T> implements TableDataSource<T> {
  readonly #data: TablePage<T>;

  constructor(data: T[]) {
    this.#data = {
      pagination: {
        page: 1,
        size: data.length,
        totalCount: data.length,
      },
      data: [...data],
    };
  }

  getData$(): Observable<TablePage<T>> {
    return of(this.#data);
  }

  get isLoading$(): Observable<boolean> {
    return new BehaviorSubject(false).asObservable();
  }
}
